import styled from 'styled-components';
import { Ico96, Ico20 } from 'dc/Ico';

export const ChartWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  background: #fff;
`;

type IconOverlayProps = {
  $iconOffset: number;
};

export const IconOverlay = styled.div<IconOverlayProps>`
  display: flex;
  z-index: 10;
  position: absolute;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: ${props => props.$iconOffset}px;
`;

export const LargeIcon = styled(Ico96)``;

export const SmallIcon = styled(Ico20)``;
